import type { ArticleItem } from '@/mocks/articleData';
import { Link } from 'react-router-dom';

interface ArticleCardProps {
  article: ArticleItem;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-all hover:scale-[1.02] flex flex-col sm:flex-row">
      <Link to={`/article/${article.id}`} className="sm:w-48 flex-shrink-0 overflow-hidden">
        <img
          src={article.cover}
          alt={article.title}
          title={`${article.title} - 青青草视频影视资讯`}
          className="w-full h-48 sm:h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
      </Link>
      <div className="p-4 flex flex-col justify-between flex-1">
        <div>
          <Link to={`/article/${article.id}`} className="no-underline">
            <h3 className="text-base md:text-lg font-medium text-foreground-900 line-clamp-2 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
              {article.title}
            </h3>
          </Link>
          <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed mb-3">
            {article.excerpt}
          </p>
        </div>
        <div className="flex items-center gap-3 text-xs text-foreground-400 flex-wrap">
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-time-line"></i>
            {article.date}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line"></i>
            {article.views}阅读
          </span>
          <span className="bg-accent-100 text-accent-700 px-2 py-0.5 rounded-md text-xs whitespace-nowrap">
            {article.category}
          </span>
        </div>
      </div>
    </article>
  );
}